import React, { memo } from "react";
import PropTypes from "prop-types";
import { Box, IconButton, Tooltip } from "@material-ui/core";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import DescriptionIcon from "@material-ui/icons/Description";
import EditIcon from "@material-ui/icons/Edit";
import { DOWNLOAD_TYPES } from "../constants";

/**
 * Row action buttons for permit table
 * Displays download (DOCX/PDF) and edit buttons for each permit row
 *
 * @component
 * @param {Object} props
 * @param {Object} props.rowData - The permit row data
 * @param {Function} props.onDownload - Callback for download action (type, rowData)
 * @param {Function} props.onEdit - Callback for edit action (id)
 */
const PermitActionsCell = memo(({ rowData, onDownload, onEdit }) => {
  const isActive = Boolean(rowData.id);

  return (
    <Box display="flex" alignItems="center" style={{ gap: "4px" }}>
      <Tooltip title={isActive ? "Download DOCX" : "Permit not active"}>
        <span>
          <IconButton
            size="small"
            onClick={() => onDownload(DOWNLOAD_TYPES.SINGLE_DOCX, rowData)}
            disabled={!isActive}
          >
            <DescriptionIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title={isActive ? "Download PDF" : "Permit not active"}>
        <span>
          <IconButton
            size="small"
            onClick={() => onDownload(DOWNLOAD_TYPES.SINGLE_PDF, rowData)}
            disabled={!isActive}
          >
            <PictureAsPdfIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title={isActive ? "Edit Permit" : "Permit not active"}>
        <span>
          <IconButton
            size="small"
            onClick={() => onEdit(rowData.id)}
            disabled={!isActive}
          >
            <EditIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
});

PermitActionsCell.propTypes = {
  rowData: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    permit_ndx: PropTypes.number,
    permit_number: PropTypes.string,
  }).isRequired,
  onDownload: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
};

PermitActionsCell.displayName = "PermitActionsCell";

export default PermitActionsCell;
